import { useEffect, useState } from 'react';

const DEFAULT_DEBOUNCE_DELAY = 100;

export const useDebouncedValue = <T>(value: T, delay: number = DEFAULT_DEBOUNCE_DELAY): T => {
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [value, delay]);

    return debouncedValue;
};
